import { render, staticRenderFns } from "./rkRecord.vue?vue&type=template&id=03db4681"
import script from "./rkRecord.vue?vue&type=script&lang=js"
export * from "./rkRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports